import { useContractDetails } from '@/modules/workforce/Contracts/components/Details/logic';
import { IContracts } from '@/modules/workforce/Contracts/types';
import { Table } from '@/shared/components/atoms';

const UnitsTable: React.FC<{ units: IContracts.IPriceUnit[] }> = ({
  units,
}) => {
  const { getUnitsTable } = useContractDetails();

  return (
    <Table<IContracts.IPriceUnit>
      pagination={false}
      perPage={10}
      selection={false}
      data={units}
      columns={getUnitsTable()}
      footerClassName='bg-neutralVariant-95'
      headCellClassName='text-start border-b-xs border-neutralVariant-90 text-surface-10 font-semi-bold'
      rowCellClassName='border-b-xs border-neutralVariant-90'
      headContainerClassName='!bg-background-neutral-99'
      tableWrapperClassName='!rounded-xl border-xs border-outline-variant'
    />
  );
};

export default UnitsTable;
